<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" data-testid="menu-profil-bouton">
  <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #menu="matMenu" xPosition="before">
  <button mat-menu-item (click)="goToParameter()" data-testid="menu-profil-parametres">
    <mat-icon>build</mat-icon>
    <span>Paramètres</span>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="configMenu" *ngIf="isAdmin()" (click)="goToAdministration()">
    <mat-icon>settings</mat-icon>
    <span>Configuration</span>
  </button>
  <button mat-menu-item (click)="logout()" data-testid="menu-profil-deconnexion">
    <mat-icon>logout</mat-icon>
    <span>Déconnexion</span>
  </button>
</mat-menu>
<mat-menu #configMenu="matMenu">
  <button mat-menu-item (click)="goToReleaseNotes()">
    <mat-icon>description</mat-icon>
    <span>Notes de version</span>
  </button>
  <button mat-menu-item (click)="goToGlobalSettings()">
    <mat-icon>settings</mat-icon>
    <span>Paramètres globaux</span>
  </button>
</mat-menu>
